import React, {
    useMemo,
} from "react";

import {
    NavLink,
} from "react-router-dom";

import {
    FiCalendar,
    FiClock,
    FiCreditCard,
    FiDollarSign,
    FiFileText,
    FiShield,
    FiUsers,
} from "react-icons/fi";

import {
    useSelector,
} from "react-redux";

import {
    selectTenantPermissions,
    selectTenantRole,
    selectTenantUser,
} from "../../../../../../store/tenantProfile/tenantProfileSlice";

import "./EmployeeCommon.css";


const normalizePermission = (
    value
) => {

    if (
        typeof value ===
        "object"
    ) {

        return String(
            value?.code ||
            ""
        )
            .trim()
            .toLowerCase();

    }


    return String(
        value ||
        ""
    )
        .trim()
        .toLowerCase();

};


const EmployeeModuleTabs = () => {

    const permissions =
        useSelector(
            selectTenantPermissions
        ) ||
        [];


    const role =
        useSelector(
            selectTenantRole
        );


    const user =
        useSelector(
            selectTenantUser
        );


    const isOwner =
        Boolean(
            user?.isOwner
        ) ||
        String(
            role?.code ||
            ""
        )
            .trim()
            .toUpperCase() ===
        "OWNER";


    const permissionSet =
        useMemo(
            () =>
                new Set(
                    permissions
                        .map(
                            normalizePermission
                        )
                        .filter(
                            Boolean
                        )
                ),
            [
                permissions,
            ]
        );


    const can =
        (
            permissionCode
        ) => {

            if (
                isOwner
            ) {

                return true;

            }


            return permissionSet
                .has(
                    normalizePermission(
                        permissionCode
                    )
                );

        };


    const tabs =
        useMemo(
            () => {

                const list = [];


                if (
                    can(
                        "employee.view"
                    )
                ) {

                    list.push({
                        path:
                            "/employees",

                        exact:
                            true,

                        label:
                            "Employees",

                        icon:
                            FiUsers,
                    });

                }


                if (
                    can(
                        "employee.attendance.view"
                    )
                ) {

                    list.push({
                        path:
                            "/employees/attendance",

                        label:
                            "Attendance",

                        icon:
                            FiClock,
                    });

                }


                if (
                    can(
                        "employee.leave.view"
                    )
                ) {

                    list.push({
                        path:
                            "/employees/leaves",

                        label:
                            "Leave",

                        icon:
                            FiCalendar,
                    });

                }


                if (
                    can(
                        "employee.salary.view"
                    )
                ) {

                    list.push({
                        path:
                            "/employees/salary",

                        label:
                            "Salary",

                        icon:
                            FiDollarSign,
                    });

                }


                if (
                    can(
                        "employee.offer.view"
                    )
                ) {

                    list.push({
                        path:
                            "/employees/offers",

                        label:
                            "Offer & Onboarding",

                        icon:
                            FiFileText,
                    });

                }


                if (
                    can(
                        "employee.advance.view"
                    )
                ) {

                    list.push({
                        path:
                            "/employees/advances",

                        label:
                            "Advance",

                        icon:
                            FiCreditCard,
                    });

                }


                if (
                    can(
                        "employee.role.view"
                    )
                ) {

                    list.push({
                        path:
                            "/employee/role-permission",

                        label:
                            "Roles & Permissions",

                        icon:
                            FiShield,
                    });

                }


                return list;

            },
            [
                permissionSet,
                isOwner,
            ]
        );


    return (

        <div className="employee-module-tabs">

            {
                tabs.map(
                    (
                        tab
                    ) => {

                        const Icon =
                            tab.icon;


                        return (

                            <NavLink
                                key={
                                    tab.path
                                }
                                exact={
                                    tab.exact
                                }
                                to={
                                    tab.path
                                }
                                className="employee-module-tab"
                                activeClassName="active"
                            >

                                <Icon />

                                <span>
                                    {tab.label}
                                </span>

                            </NavLink>

                        );

                    }
                )
            }

        </div>

    );

};


export default EmployeeModuleTabs;
